import React from "react";
import { LuSwords } from "react-icons/lu";

const Competitors = ({ data }) => {
  return (
    <div className="rounded-xl bg-white py-2 flex flex-col gap-4">
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <LuSwords className="w-7 h-7 text-gray-600" />
            <h2 className="text-xl font-bold tracking-tight">
              Competitor Analysis
            </h2>
          </div>
          <button
            className="px-6 py-2 rounded-lg border-2 border-orng text-orng font-semibold hover:bg-orng hover:text-white transition-colors shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-orng focus:ring-offset-2"
            onClick={() => {
              window.location.href = "/competitor-analysis";
            }}
          >
            View More
          </button>
        </div>
      </div>
      <div className="flex flex-row gap-4">
        {data.selected_companies.map((company, index) => (
          <div
            key={index}
            className="flex-1 border rounded-xl p-6 shadow-md hover:shadow-lg text-left"
            onClick={() => {
              window.location.href = "/competitor-analysis";
            }}
          >
            <h3 className="text-lg font-bold mb-2 text-bl">{company.name}</h3>
            <p className="text-sm">{company.description}</p>
          </div>
        ))}
        <div
          className="flex-1 border rounded-xl p-6 shadow-md hover:shadow-lg bg-orng text-white text-left"
          onClick={() => {
            window.location.href = "/competitor-analysis";
          }}
        >
          <h3 className="text-lg font-bold mb-2">Your Differentiation</h3>
          <p className="text-sm font-bold">{data.differentiation}</p>
        </div>
      </div>
    </div>
  );
};

export default Competitors;